import type { Selector } from 'core/core.selectors';
import { createSelector } from 'reselect';
import type { Product } from '@protector/entities/product/models';
import type { ProductState } from '@protector/entities/product/__legacy__/redux.types';
import { selectAllProducts } from './product.reducer';

export const getProductEntitiesInEntities: Selector<ProductState['entities']> = state => state.entities.product.entities;

export const getAllProducts: Selector<Product[]> = state => selectAllProducts(state.entities.product);

export const getProductLoaded: Selector<ProductState['productLoaded']> = state => state.entities.product.productLoaded;

export const getDeletedProductsFromProductEntities = createSelector(getProductEntitiesInEntities, products => {
  const deleted: Product[] = [];
  for (const product in products) {
    if (Object.hasOwn(products, product)) {
      const safeProduct = products[product];
      if (safeProduct.deleted_at) {
        deleted.push(safeProduct);
      }
    }
  }
  return deleted;
});

export const getProductsError: Selector<ProductState['error']> = state => state.entities.product.error;
export const getProductsLoading: Selector<ProductState['isLoading']> = state => state.entities.product.isLoading;
